export default {"src":"/_next/static/media/playground.424d0070.svg","height":27,"width":29,"blurWidth":0,"blurHeight":0};